import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, VIEW } from "const"
import {
    StateType,
    hasProjectAccess,
} from "client/utils"
import {
    PRM_STUDY,
    StoreType,
    StudyProps,

    LoadAllRrsCategories,
    LoadStudyById,

    setRrsCategoryList,
    setRrsCategoryChildParent,
    setStudyView,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Collapse,
    Loader,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"
import NotFound from "client/parts/notFound"

import TeamMembers from "client/pages/study/teamMember/list"
import Form from "./form"

const View = ({
    studyId = null,
}: StudyProps) => {
    const study = useSelector((state: StoreType) => state.study.studyView)
    const reloadView = useSelector((state: StoreType) => state.study.reloadView)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const accountSettings = useSelector((state: StoreType) => state.system.accountSettings)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadCategoriesState, setLoadCategoriesState] = useState<StateType>(IDLE)
    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        // load categories for displaying "systemStage" and "status" category
        setLoadCategoriesState(PENDING)
        if (accountSettings.rrs.defaultCategoriesAssigned) {
            LoadAllRrsCategories(userData.accountId, null).then((res) => {
                dispatch(setRrsCategoryList(res.categoryList))
                dispatch(setRrsCategoryChildParent(res.childParent))
                setLoadCategoriesState(IDLE)
            })
        } else {
            LoadAllRrsCategories(1, null).then((res) => {
                // data are used only for displaying, no need to select only published
                dispatch(setRrsCategoryList(res.categoryList))
                dispatch(setRrsCategoryChildParent(res.childParent))
                setLoadCategoriesState(IDLE)
            })
        }
    }, [])

    useEffect(() => {
        if (!reloadView) return
        setLoadState(PENDING)
        LoadStudyById(studyId, project.id)
        .then((res) => {
            dispatch(setStudyView(res))
            setLoadState(IDLE)
        })
    }, [reloadView])

    const viewAccess = hasProjectAccess(PRM_STUDY, VIEW)

    if (!viewAccess) return <AccessDenied />
    if (!study) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{`${lang.viewStudy} # ${study.id || ""}`}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    (
                        loadCategoriesState === PENDING
                        || loadState === PENDING
                    ) && <Loader />
                }
                <Form />

                <Collapse show title={lang.teamMembers}>
                    <TeamMembers studyId={studyId} />
                </Collapse>
            </PageContent>
        </Container>
    )
}
export default View
